module.exports = __webpack_public_path__ + "assets/media/temple-day.92d21846.ogg";